//TH-XG750
(function($) {
  var objss = {
    isFilterAjaxClick: false,
    loadingtimeout: null,

    init: function() {
      console.log("objss.init()");
      this.shopifyParam();
      this.initSidebar();
      this.initToolbar();
      $('.filter-tags dd > ol').each(function() {
        if (!$(this).children().length) {
          console.log("Empty filter-tags found, hiding");
          $(this).parents('dd').css('display', 'none');
          $(this).parents('dd').prev().css('display', 'none');
        }
      });
    },

    initSidebar: function() {
      console.log("initSidebar()");
      if ($(".block-layered-nav").length > 0) {
        this.typeEvents();
        this.filterClear();
        this.sidebarModeView();
      }
    },

    shopifyParam: function() {
      console.log("shopifyParam()");
      Shopify.queryParams = {};
      if (location.search.length) {
        var aCouples = location.search.substr(1).split('&');
        for (var i = 0; i < aCouples.length; i++) {
          var aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
      console.log("Shopify.queryParams:", Shopify.queryParams);
    },

    initToolbar: function() {
      console.log("initToolbar()");
      if (Shopify.queryParams.sort_by) {
        var sortValue = Shopify.queryParams.sort_by;
        $(".filters-toolbar__input--sort option[value='"+sortValue+"']").attr("selected","selected");
      }
    },

    sidebarModeView: function() {
      console.log("sidebarModeView()");
      $(".filters-toolbar-wrapper .changeView").click(function(e) {
        if (!$(this).hasClass("active")) {
          var paging = $(".filter-show > button span").text() || "12";
          if ($(this).data("view") == 'list') {
            Shopify.queryParams.view = "list" + paging;
          } else {
            Shopify.queryParams.view = paging;
          }
          objss.ajaxClick();
          $(".filters-toolbar-wrapper .changeView").removeClass("active");
          $(this).addClass("active");
        }
        e.preventDefault();
      });
    },

    initSortbyEvent: function() {
      console.log("initSortbyEvent()");
      $(document).on('change', '.filters-toolbar .filters-toolbar__input--sort', function(e) {
        Shopify.queryParams.sort_by = $(this).val();
        objss.ajaxClick();
        $(".filters-toolbar__input--sort option[value='"+$(this).val()+"']").attr("selected","selected");
        e.preventDefault();
      });
    },

    initCountProduct: function() {
      console.log("initCountProduct() — no logic defined yet");
    },

    sidebarCreateUrl: function(baseLink) {
      var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      var fullUrl = baseLink ? (newQuery ? baseLink + "?" + newQuery : baseLink) : location.pathname + "?" + newQuery;
      return fullUrl;
    },

    typeEvents: function() {
      this.filterByTags();
      this.initSortbyEvent();
      this.initCountProduct();
    },

    filterByTags: function() {
      $('.filter-tags dd ol li label').click(function(e) {
        var currentTags = [];
        if (Shopify.queryParams.constraint) {
          currentTags = Shopify.queryParams.constraint.split('+');
        }

        if (!window.enable_sidebar_multiple_choice && !$(this).prev().is(":checked")) {
          var otherTag = $(this).parent('.filter-tags').find("input:checked");
          if (otherTag.length > 0) {
            var tagName = otherTag.val();
            var tagPos = currentTags.indexOf(tagName);
            if (tagPos >= 0) {
              currentTags.splice(tagPos, 1);
            }
          }
        }

        var tagName = $(this).prev().val();
        if (tagName) {
          var tagPos = currentTags.indexOf(tagName);
          if (tagPos >= 0) {
            currentTags.splice(tagPos, 1);
          } else {
            currentTags.push(tagName);
          }
        }

        Shopify.queryParams.constraint = currentTags.length ? currentTags.join('+') : undefined;
        objss.ajaxClick();
        e.preventDefault();
      });
    },

    ajaxClick: function(baseLink) {
      delete Shopify.queryParams.page;
      var newurl = this.sidebarCreateUrl(baseLink);
      this.isFilterAjaxClick = true;
      History.pushState({ param: Shopify.queryParams }, newurl, newurl);
      this.ajaxGetContent(newurl);
    },

    ajaxGetContent: function(newurl) {
      $.ajax({
        type: 'get',
        url: newurl,
        beforeSend: function() {
          objss.showLoading();
        },
        success: function(data) {
          objss.hideLoading();
          objss.pageData(data);
          objss.filterByTags();
          objss.filterClear();
          $('.filter-tags dd > ol').each(function() {
            if (!$(this).children().length) {
              $(this).parents('dd').css('display', 'none');
              $(this).parents('dd').prev().css('display', 'none');
            }
          });
        },
        error: function(xhr, text) {
          objss.hideLoading();
        }
      });
    },

    pageData: function(data) {
      var modeType = $(".changeView.mode-list.active");
      var grid_class = $("#ProductCollectionContainer");
      if(modeType.length > 0){
        grid_class.addClass('listing-mode');
      } else {
        grid_class.removeClass('listing-mode');
      }

      var current_class = $(".product-grid-container .product-grid");
      if (current_class.length == 0) {
        current_class = $(".product-grid-container .product-list");
      }

      var content = $(data).find(".product-grid-container .product-grid");
      if (content.length == 0) {
        content = $(data).find(".col-main .product-list");
      }

      if (content.length == 0) {
        console.log("Error: No product grid or list found in AJAX response");
        return;
      }

      current_class.replaceWith(content);

      if ($(".padding").length > 0) {
        $(".padding").replaceWith($(data).find(".padding"));
      } else {
        $(".col-main").append($(data).find(".padding"));
      }

      $('.product-card__gallery .item-img').on("mouseover touchstart", function (e) {
        var thumb_src = $(this).attr("data-src");
        $(this).addClass('thumb-active').siblings().removeClass('thumb-active');
        $(this).closest('.product-item-container').find('.img-responsive.s-img').attr("src", thumb_src);
      });

      var currentHeader = $(".collection_info");
      var dataHeader = $(data).find(".collection_info");
      if (currentHeader.find("h3.page-title").text() != dataHeader.find("h3.page-title").text()) {
        currentHeader.find("h3.page-title").replaceWith(dataHeader.find("h3.page-title"));
      }

      var currentDes = $(".collection-des");
      var dataDes = $(data).find(".collection-des");
      if (currentDes.length) {
        dataDes.length ? currentDes.html(dataDes) : currentDes.hide();
      } else {
        currentHeader.append('<div class="collection-des"></div>');
        $(".collection-des").html(dataDes);
      }

      if (Shopify.queryParams.sort_by) {
        $(".filters-toolbar__input--sort option[value='"+Shopify.queryParams.sort_by+"']").attr("selected", "selected");
      }

      $(".filter-tags").replaceWith($(data).find(".filter-tags"));

      if ($(".spr-badge").length > 0) {
        return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
      }
    },

    filterClear: function() {
      $(".filter-tags dd ol li").each(function() {
        var sidebarTag = $(this);
        if (sidebarTag.find("input:checked").length > 0) {
          sidebarTag.parent().parent().prev().find(".clear").show().click(function(e) {
            var currentTags = [];
            if (Shopify.queryParams.constraint) {
              currentTags = Shopify.queryParams.constraint.split('+');
            }

            sidebarTag.find("input:checked").each(function() {
              var tagName = $(this).val();
              var tagPos = currentTags.indexOf(tagName);
              if (tagPos >= 0) currentTags.splice(tagPos, 1);
            });

            Shopify.queryParams.constraint = currentTags.length ? currentTags.join('+') : undefined;
            objss.ajaxClick();
            e.preventDefault();
          });
        }
      });
    },

    reActivateSidebar: function() {
      $(".filter-category .active").removeClass("active");
      $(".filter-tags input:checked").prop("checked", false);
      var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
      if (cat && cat[1]) {
        $(".filter-category a[href='" + cat[0] + "']").addClass("active");
      }
    },

    showLoading: function() {
      $('.ss-loading').show();
    },

    hideLoading: function() {
      $('.ss-loading').hide();
    }
  };

  $(document).ready(function() {
    objss.init();
    $('.filter-tags dd ol li label').click(function(e) {
      objss.ajaxClick();
    });
  });

  if ($(".block-layered-nav").length) {
    History.Adapter.bind(window, 'statechange', function() {
      var State = History.getState();
      if (!objss.isFilterAjaxClick) {
        objss.shopifyParam();
        var newurl = objss.sidebarCreateUrl();
        objss.ajaxGetContent(newurl);
        objss.reActivateSidebar();
      }
      objss.isFilterAjaxClick = false;
    });
  }
})(jQuery);
